import Vue from 'vue'
import IdleVue from 'idle-vue'

import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueSkeletonLoader from 'skeleton-loader-vue'
import elTableInfiniteScroll from 'el-table-infinite-scroll'
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)
import router from './router'
import store from './store'
import App from './App.vue'
import directives from '@core/directives'
import { i18n } from './libs/i18n-setup'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
Vue.use(BootstrapVue)

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
// import '@/libs/toastification'

// Import the Auth0 configuration
import { domain, clientId } from '../auth_config.json'

// Import the plugin here
import { Auth0Plugin } from './auth'

import './registerServiceWorker'
import { useFilter } from '@core/utils/filter'

// Create Event Bus
export const bus = new Vue()

// Spy Glass Plugin
// import SpyGlass from '@spy-glass/connector-vue'
// Vue.use(SpyGlass, {
//   apikey: 'b531b4bd8f43b4be8a3dae2f9015edcfbf7fa39b8ff2e3c3d9c1410e26c7fc02'
// })

// Install the authentication plugin here

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    // router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
    history.replaceState({}, document.title, window.location.pathname)
    router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
  }
})

// Register the component globally
Vue.component('vue-loading-skeleton', VueSkeletonLoader)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(directives)
Vue.use(elTableInfiniteScroll)

// Composition API
Vue.use(VueCompositionAPI)

// Idle timeout
Vue.use(IdleVue, {
  eventEmitter: bus,
  idleTime: 60 * 60 * 1000, // 1 hour
  startAtIdle: false,
  store
})

useFilter(Vue)

// Icons
require('@core/assets/fonts/feather/iconfont.css')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
const requireComponent = require.context('./components', true, /Md.*\.vue$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = componentConfig.default.name
  Vue.component(componentName, componentConfig.default || componentConfig)
})
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  onIdle() {
    console.log('Idling')
  },
  onActive() {
    console.log('Active')
  }
}).$mount('#app')
